<dk-header
  class="layout-header"
  [menuToggleEnabled]="true"
  (menuToggle)="menuOpened = !menuOpened"
  [title]="'Dabnet'"
></dk-header>
<dx-drawer
  class="layout-body"
  position="before"
  [closeOnOutsideClick]="shaderEnabled"
  [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode"
  [minSize]="minMenuSize"
  [shading]="shaderEnabled"
  [(opened)]="menuOpened"

>
<div class="layout-content" data-tam-ekran-kok>

  <dk-side-navigation-menu
  [compactMode]="!menuOpened"
  [selectedItem]="selectedRoute"
  class="dx-swatch-additional"
  *dxTemplate="let dataMenu of 'panel'"
  (selectedItemChanged)="navigationChanged($event)"
  (openMenu)="navigationClick()"
  (menuyuGenislet)="temporaryMenuOpened = false; menuOpened = true"
  >
</dk-side-navigation-menu>

<router-outlet class="router"></router-outlet>

<!-- Tam ekranda açık sekmede düğmeli başlık görünmüyorsa çıkış düğmesi -->
<button *ngIf="(tamEkran.aktif$ | async) && !tamEkran.gorunurSahipVar" type="button" class="tam-ekran-cik"
        title="Tam ekrandan çık (Esc)" aria-label="Tam ekrandan çık" (click)="tamEkran.degistir()">
  <i class="dx-icon dx-icon-collapse"></i>
</button>

</div>
</dx-drawer>
